import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

const ProductsProfessionalsLoxoneStyled = styled.div`
  width: 100%;

  .section-one {
    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 55%;

      @media (max-width: ${breakpoints.screenMD}) {
        align-items: center;
        text-align: center;
        width: 100%;
      }
    }

    .img {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      width: 45%;

      @media (max-width: ${breakpoints.screenMD}) {
        width: 80%;
        margin-bottom: 2rem;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        width: 90%;
      }

      &.hide-lg {
        display: none;

        @media (max-width: ${breakpoints.screenMD}) {
          display: flex;
        }
      }

      &.hide-md {
        display: flex;

        @media (max-width: ${breakpoints.screenMD}) {
          display: none;
        }
      }
    }

    .title {
      max-width: 630px;
      margin-bottom: 1.5rem;
    }

    .text {
      max-width: 500px;
    }

    .scroll {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      cursor: pointer;

      @media (max-width: ${breakpoints.screenMD}) {
        display: none;
      }
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      text-align: left;
    }

    .list-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .item-icon {
      min-width: 64px;
    }
  }

  .section-two {
    .title {
      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 345px;
      }
    }

    .logos {
      max-width: 470px;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 430px;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 300px;
        height: 280px;
      }

      &.hide-lg {
        display: none;

        @media (max-width: ${breakpoints.screenSM}) {
          display: block;
        }
      }

      &.hide-sm {
        display: block;

        @media (max-width: ${breakpoints.screenSM}) {
          display: none;
        }
      }
    }
  }

  .section-three {
    padding-left: 0;
    padding-right: 0;

    .title {
      margin-bottom: 1.5rem;
      max-width: 800px;
    }

    .text {
      max-width: 950px;
      margin-bottom: 1.5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 100%;
      }
    }
  }

  .section-four {
    .title {
      margin-bottom: 3rem;
      text-align: center;

      @media (max-width: ${breakpoints.screenMD}) {
        margin-bottom: 0.5rem;
      }
    }
  }
`

export default ProductsProfessionalsLoxoneStyled
